import { useDataSubmit } from 'Simple/Data.js'

export function useOnPatientOverlayClose(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'global',
  })

  return () => {
    submit({ type: 'patientOverlay/close' })
  }
}
